import { Injectable } from "@angular/core";
import { RestServiceBase } from "@definitiv-packages/angular-dba-library";
import { ObjektModel } from "../../../public-api";

@Injectable({
    providedIn: 'root'
})
export class ObjektService extends RestServiceBase<ObjektModel> {
    constructor(
    ) {
        super("ObjektModel", false);
    }
}